export default __webpack_public_path__ + "static/media/computerLady5M.3b951c6c.jpg";